import { COLOR_NEUTRAL_600 } from '@alltrails/denali/tokens';
import getPOIIcon from '@alltrails/search/utils/getPOIIcon';
import type { POISubType } from '@alltrails/types/AlgoliaResults';
import { createIconPinSvg, POIPinSize } from './svgMarkerComponents';

export const imageNamePrefix = 'poi-pin';
export const getImageName = (type: POISubType, size: POIPinSize) => `${imageNamePrefix}-${type}-${size}`;
const createPOIIconPinSvg = (type: POISubType, size: POIPinSize, color?: string, iconFill?: string) =>
  createIconPinSvg(getImageName(type, size), getPOIIcon(type, true /* filled */), size, color ?? COLOR_NEUTRAL_600, iconFill);

export default createPOIIconPinSvg;
